import pathToRegexp from 'path-to-regexp'

const AP_PATH = '/Hotel/:slug'
const AP_REGEX = pathToRegexp(AP_PATH)

/**
 * Returns the hotelId from URL slug
 * We parse the URL ourselves because normalization to /Hotel/0000 in vreq lambda causes issues with `router.query`
 */
export const useHotelSlug = () => {
  if (typeof window === 'undefined') return null

  // AP regex also matches SRP, and some of these hooks are mounted on SRP as well.
  if (window.location.pathname.startsWith('/Hotel/Search')) return null

  const location = window.location.pathname
  const match = AP_REGEX.exec(location)
  return match && match.length > 1 ? match[1] : null
}
